import React from 'react';
import { Field } from 'redux-form';
import { PropTypes } from 'prop-types';

import { CHECKBOX, RADIO } from '../constants';
import { STATIC_ROOT } from '../../../constants';

import SvgComponent from '../../SvgComponent';
import { FormInputContainerComponent, ItemComponent } from '../InputWrappersComponent';

const optionsGroup = ({
    input,
    meta,
    options,
    typeBox,
    classNameInputContainer,
    label,
    isInlineLabel,
    isRequired,
    hideLabel,
    handleChecked,
    disabled,
    getInputName,
    handleOnChange,
    getInputValue,
    handleOnKeyDown,
    onClick
}) => {
    const currentValue = getInputValue(input, typeBox);
    const hasError = meta.touched && meta.error;
    const errorId = `error-${input.name}-${meta.form}`;

    const optionsContent = (
        <ItemComponent className="item">
            <div className="options-box-input flex-container-h flex-center-alt">
                {options.map((option, index) => {
                    return (
                        <div
                            className="option-box-input flex-container-h flex-center-alt"
                            key={`${typeBox}-${index}`}>
                            <input
                                type={typeBox}
                                name={getInputName(input, index, typeBox)}
                                value={option.value}
                                checked={handleChecked(currentValue, option.value, typeBox)}
                                id={`${input.name}-${index}`}
                                className="box-input box-input-g-xl"
                                disabled={disabled}
                                aria-required={isRequired}
                                aria-invalid={hasError ? 'true' : undefined}
                                aria-describedby={hasError ? errorId : undefined}
                                onChange={event =>
                                    input.onChange(
                                        handleOnChange(event, currentValue, option.value, typeBox)
                                    )
                                }
                                onKeyDown={event =>
                                    handleOnKeyDown(event, `${input.name}-${index}`)
                                }
                                onClick={onClick}
                            />
                            <label
                                htmlFor={`${input.name}-${index}`}
                                className="box-input-label flex-container-h flex-center-alt">
                                {option.label}
                            </label>
                        </div>
                    );
                })}
            </div>
        </ItemComponent>
    );

    return (
        <FormInputContainerComponent
            className={`${classNameInputContainer ? classNameInputContainer : ''}${
                hideLabel ? ' hidden-label' : ''
            }`}>
            {label ? (
                <fieldset className="item-wrapper-box-input flex-container-h flex-center-alt">
                    <legend className={`label ${hideLabel ? 'sr-only' : ''}`}>{label}</legend>
                    {optionsContent}
                </fieldset>
            ) : (
                <div className="item-wrapper-box-input flex-container-h flex-center-alt">
                    {optionsContent}
                </div>
            )}
            {hasError && (
                <p className="input-error color-err" id={errorId}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/picto-errors.svg`}
                        width={20}
                        height={20}
                        aria-hidden="true"
                        focusable="false"
                    />
                    {meta.error}
                </p>
            )}
        </FormInputContainerComponent>
    );
};
/**
 *
 * sidenote : we don't pass type props to Field because there is a bug whe, passing radio type to field,
 * so we passed a typeBox props and in the rendered component we set the real type ! HACK
 */
class BoxInputFieldComponent extends React.Component {
    render() {
        const { options, name, typeBox, validate, label, isRequired } = this.props;
        return (
            <Field
                {...this.props}
                name={name}
                label={`${label ? label : ''}${label && isRequired ? '*' : ''}`}
                options={options}
                typeBox={typeBox}
                validate={validate}
                component={optionsGroup}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
BoxInputFieldComponent.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    typeBox: PropTypes.oneOf([CHECKBOX, RADIO]).isRequired,
    isInlineLabel: PropTypes.bool,
    i18nFeatureForm: PropTypes.object.isRequired
};

export default BoxInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/boxInput/BoxInputFieldComponent.js